export default __webpack_public_path__ + "static/media/gia-table@3x.774e7266.png";